import type { FormatOptionLabelMeta } from "ui/select";
import { type SxProps, type Theme } from "@mui/material/styles";
import { twMerge } from "tailwind-merge";

import { Chip } from "ui/chip";
import { TruncatedText } from "ui/truncated-text";
import { StatusIndicator } from "components/partials/status-indicator/status-indicator";

import { getBatchStatuses } from "containers/admin/clients/client/approval-queue/approval-queue.helpers";

import Icons from "assets";

type BatchSelectOptionLabelProps = {
  batchName: string;
  versionStatuses: ReturnType<typeof getBatchStatuses>;
  isCurrentBatch?: boolean;
  /** `"menu"` shows the full name; `"value"` truncates it and surfaces the rest in a tooltip. */
  context?: FormatOptionLabelMeta["context"];
};

const BATCH_NAME_WRAPPER_SX: SxProps<Theme> = { flex: "1 1 0%" };

const BatchSelectOptionLabel = ({
  batchName,
  versionStatuses,
  isCurrentBatch = false,
  context = "menu",
}: BatchSelectOptionLabelProps) => {
  const isMenuContext = context === "menu";

  return (
    <span className={twMerge("flex min-w-0 items-center gap-3", isMenuContext && "flex-wrap")}>
      {isMenuContext ? (
        <span className="min-w-0 break-words">{batchName}</span>
      ) : (
        <TruncatedText text={batchName} wrapperSx={BATCH_NAME_WRAPPER_SX} />
      )}
      <span className={twMerge("flex items-center gap-3", !isMenuContext && "shrink-0")}>
        <StatusIndicator versionStatuses={versionStatuses} />
        {isCurrentBatch && (
          <Chip
            size="small"
            variant="outlined"
            label="Current batch"
            icon={<Icons.Layers aria-hidden="true" />}
          />
        )}
      </span>
    </span>
  );
};

export default BatchSelectOptionLabel;
